/**
 * Place hold a given value if it is empty.
 *
 * @param value
 * @param type
 * @param placeholder
 */
export function placehold(value, type = 'integer', placeholder = 'TBC') {
    if (type === 'integer') {
        return !value || !parseInt(value) || parseInt(value) <= 0 ? placeholder : value;
    }
    return !value || typeof value === 'string' && value.length === 0 ? placeholder : value;
}
